import { render } from "./shareInvitefriend.vue?vue&type=template&id=f4527e44"
import script from "./shareInvitefriend.vue?vue&type=script&lang=js"
export * from "./shareInvitefriend.vue?vue&type=script&lang=js"

import "./shareInvitefriend.vue?vue&type=style&index=0&id=f4527e44&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__